import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

import type { FlagConnectionParams } from "@/react/api/connectionsApi";
import { connectionsApi } from "@/react/api/connectionsApi";

export const useFlagConnection = (
  options?: UseMutationOptions<unknown, Error, FlagConnectionParams>,
) =>
  useMutation({
    mutationFn: (params: FlagConnectionParams) =>
      connectionsApi.flagConnection(params),
    ...options,
  });
